import api from 'config/api/protectedApi';
import { apiRoutes } from 'config/api/apiRoutes';
import { IPaginatedList } from 'models/commonModel';
import { IOrderSettings, IOrder, ISendInvoiceRequestData, IOrderStatusLookup, IOrderDetails, IOrderFormData } from 'models/ordersModel';
import useError from 'utils/useError';

export const useOrderApi = () => {
  const { throwException } = useError();

  async function getOrdersList(pageParam: number, pageSize: number, languageCode: string | undefined): Promise<IPaginatedList<IOrder>> {
    return api
      .get(apiRoutes.getOrders, {
        params: {
          pageIndex: pageParam,
          pageSize: pageSize,
          languageCode: languageCode,
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
  async function getOrderSettings(languageCode: string): Promise<IOrderSettings> {
    return api
      .get(apiRoutes.getOrderSettings, {
        params: {
          languageCode: languageCode,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  async function updateOrderSettings(data: IOrderSettings): Promise<IOrderSettings> {
    return api
      .put(apiRoutes.updateOrderSettings, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }
   const sendOrderInvoice = (data: ISendInvoiceRequestData): Promise<boolean> => {
    return api.post(apiRoutes.sendOrderInvoice, data)
    .then((res) => res.data)
    .catch((error) => {
      throwException(error);
      throw error;
    });
  };

  async function getStatusList(languageCode: string) : Promise<Array<IOrderStatusLookup>> {
    return api
      .get(apiRoutes.getOrderStatusLookup, {
        params: {
          languageCode: languageCode,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  async function getOrderById(id:number, languageCode:string): Promise<IOrderDetails>{
    return api
      .get(apiRoutes.getOrderById, {
        params: {
          id: id,
          languageCode: languageCode,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }

  async function updateOrder(id: number, order: IOrderFormData,isNotify:boolean,isStatusChanged :boolean,notificationPhoneNumber?:string ,phoneNumber?:string, waTemplateId?:number
    ,templateName?:string,templateLanguage?:string): Promise<string> {
    const data = {
      id: id,
      ...order,
      isNotify:isNotify,
      merchantPhoneNumber:notificationPhoneNumber,
      reciverPhoneNumber:phoneNumber,
      waTemplateId:waTemplateId,
      waTemplateLanguage:templateLanguage,
      waTemplateName:templateName,
      isStatusChanged :isStatusChanged 
    }
    return api.post(apiRoutes.updateOrder, data)
      .then((response) => {
        return response.data;
      })
      .catch(error => {
        throwException(error)
        throw error
      });
    }
 async function exportOrdersToCsv(languageCode:string): Promise<Blob>{
  const timeZoneMinutes = new Date().getTimezoneOffset();
    return api
      .get(apiRoutes.exportOrders, {
        params: {
          languageCode: languageCode,
          timeZoneMinutes:timeZoneMinutes
        },
         responseType: 'blob',
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }
    
  return {
    getOrdersList,
    getOrderSettings,
    updateOrderSettings,
    sendOrderInvoice,
    getStatusList,
    getOrderById,
    updateOrder,
    exportOrdersToCsv
  };
};
